module.exports = function() {
  return new Worker(__webpack_public_path__ + "31f899cd83cb0c87abc2.worker.js");
};